import { useCheckEmailForm } from '@/forms/check-email.form';
import { Button, FormHelperText, TextField, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContainer } from '../components/auth-container.component';

const inputSx = {
  '& .MuiFilledInput-root': {
    bgcolor: 'white',
    borderRadius: 2,
    '&:before, &:after': { display: 'none' },
    '&:hover': { bgcolor: 'white' },
    '&.Mui-focused': { bgcolor: 'white' },
  },
};

export function AuthEmailPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = String(searchParams.get('error'));
  const { register, onSubmit, errors, isPending, getValues } =
    useCheckEmailForm({
      onSuccess: (response) => {
        const email = getValues('email');
        if (response.exists) {
          navigate(`/auth/login?email=${encodeURIComponent(email)}`);
        } else {
          navigate(`/auth/code?email=${encodeURIComponent(email)}`);
        }
      },
    });

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          color: '#02344C',
          fontWeight: 700,
          mb: 0.75,
          textAlign: 'center',
          letterSpacing: '-0.01em',
        }}
      >
        eLink Online Service
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          mb: 1,
          textAlign: 'center',
          maxWidth: 340,
          lineHeight: 1.6,
        }}
      >
        Geben Sie ihre geschäftliche E-Mail Adresse ein, um fortzufahren.
      </Typography>
      <AuthContainer component="form" onSubmit={onSubmit}>
        <TextField
          id="email"
          label="E-Mail Adresse"
          type="email"
          variant="filled"
          fullWidth
          required
          {...register('email')}
          error={!!errors.email}
          helperText={errors.email?.message}
          sx={inputSx}
        />
        {error === 'invalid_code' && (
          <FormHelperText error>
            Der Verifizierungscode ist ungültig. Bitte füllen Sie das Formular
            erneut aus und fordern Sie den Verifizierungscode erneut an.
          </FormHelperText>
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={isPending}
          sx={{
            mt: 1,
            py: 1.25,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.9rem',
          }}
        >
          {isPending ? 'Wird geprüft...' : 'Weiter'}
        </Button>
      </AuthContainer>
    </>
  );
}
